/* eslint-disable react/jsx-no-literals */
import React from 'react';
import Typography from 'carbon-react/lib/components/typography';

import * as styles from './narrative-summary-card.scss';

interface NarrativeParagraph {
  text: string;
}

interface BottomLineProps {
  label: string;
  text: string;
}

interface NarrativeSummaryCardProps {
  title?: string;
  paragraphs: NarrativeParagraph[];
  bottomLine: BottomLineProps;
}

export const NarrativeSummaryCard = ({ title, paragraphs, bottomLine }: NarrativeSummaryCardProps) => {
  return (
    <div className={styles.content}>
      {title && (
        <Typography variant="h2" fontSize="18px" fontWeight="700" lineHeight="140%" mb={3}>
          {title}
        </Typography>
      )}
      {paragraphs.map((paragraph, index) => (
        <Typography
          key={index}
          fontSize="16px"
          fontWeight="400"
          lineHeight="160%"
          mb={0}
          color="rgba(0,0,0,0.65)"
        >
          {paragraph.text}
        </Typography>
      ))}
      <div className={styles.bottomLine}>
        <Typography
          fontSize="16px"
          fontWeight="400"
          lineHeight="160%"
          mb={0}
          color="rgba(0,0,0,0.65)"
        >
          <Typography
            as="span"
            fontSize="16px"
            fontWeight="700"
            lineHeight="160%"
            color="rgba(0,0,0,0.65)"
          >
            {bottomLine.label}
          </Typography>{' '}
          {bottomLine.text}
        </Typography>
      </div>
    </div>
  );
};
